import { getPackageMetadata } from "../vendor";
import { emitErrorEvent, emitLoadEvent } from "./metrics";
function cssEscape(value) {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.CSS) === null || _a === void 0 ? void 0 : _a.escape) {
        return window.CSS.escape(value);
    }
    return value;
}
function setAttributes(element, attributes) {
    element.setAttribute("data-awsui-app-layout-widget", "true");
    for (const attribute of attributes) {
        element.setAttribute(attribute.name, attribute.value);
    }
}
function loadStyle(document, asset, basePath) {
    const styleUrl = new URL(asset.path, basePath).toString();
    if (document.querySelector(`link[href="${cssEscape(styleUrl)}"]`)) {
        return;
    }
    const stylesheet = document.createElement("link");
    stylesheet.rel = "stylesheet";
    stylesheet.href = styleUrl;
    setAttributes(stylesheet, asset.htmlAttributes);
    document.head.appendChild(stylesheet);
}
function loadScript(document, asset, basePath) {
    const scriptUrl = new URL(asset.path, basePath).toString();
    let script = document.querySelector(`script[src="${cssEscape(scriptUrl)}"]`);
    if (script) {
        return script.__awsuiLoadPromise__;
    }
    const loadPromise = new Promise((resolve, reject) => {
        script = document.createElement("script");
        script.src = scriptUrl;
        setAttributes(script, asset.htmlAttributes);
        script.addEventListener("error", () => reject(new Error("Failed to load module")));
        script.addEventListener("load", () => {
            const exports = script.__awsuiExports__;
            if (!exports) {
                reject(new Error("Failed to initialize script"));
            }
            else {
                resolve(exports);
            }
        });
        document.head.appendChild(script);
    });
    script.__awsuiLoadPromise__ = loadPromise;
    return loadPromise;
}
export async function importModule(document, packageConfig) {
    const startTime = performance.now();
    const { metadata, basePath } = await getPackageMetadata(packageConfig);
    const metadataTime = performance.now();
    loadStyle(document, metadata.assets.find((asset) => asset.tag === "link"), basePath);
    try {
        const result = await loadScript(document, metadata.assets.find((asset) => asset.tag === "script"), basePath);
        const finishTime = performance.now();
        emitLoadEvent(startTime, metadataTime, finishTime);
        return result;
    }
    catch (error) {
        emitErrorEvent(error);
        throw error;
    }
}
